<template>
  <nav class="navbar is-primary no-print" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <!-- Hamburger icon -->
      <a
        role="button"
        class="navbar-burger"
        :class="{ 'is-active': isMenuActive }"
        aria-label="menu"
        aria-expanded="false"
        @click="toggleMenu"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div class="navbar-menu" :class="{ 'is-active': isMenuActive }">
      <div class="navbar-start">
        <!-- Add your left-side navigation items here -->
      </div>

      <div class="navbar-end">
        

        <div class="navbar-item has-dropdown" :class="{ 'is-active': activeDropdown === 'eventregister' }" v-if="roleid ==1">
          <a class="navbar-link" @click.prevent="toggleDropdown('eventregister')">
            <span>ລົງທະບຽນງານ</span>
          </a>
          <div class="navbar-dropdown" v-if="activeDropdown === 'eventregister'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/eventForm"
              :exact="true"
              active-class="is-active"
            >
              <span >ລົງທະບຽນງານ</span>
            </router-link>


          </div>
        </div>

        <div class="navbar-item has-dropdown" :class="{ 'is-active': activeDropdown === 'participate' }">
          <a class="navbar-link" @click.prevent="toggleDropdown('participate')">
            <span  >ລົງທະບຽນເຂົ້າຮ່ວມງານ</span>
          </a>
          <div class="navbar-dropdown" v-if="activeDropdown === 'participate'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/participateForm"
              :exact="true"
              active-class="is-active"
            >
              <span >ລົງທະບຽນ ໂດຍຜູ້ຈັດງານ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/participateFormAtEvent"
              :exact="true"
              active-class="is-active"
            >
              <span >ລົງທະບຽນ ໜ້າງານ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/eventQRList"
              :exact="true"
              active-class="is-active"
            >
              <span >ລົງທະບຽນ ໂດຍການສະແກນ QR ງານ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/booth"
              :exact="true"
              active-class="is-active"
            >
              <span >ປະເມີນ Booth</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/boothreport"
              :exact="true"
              active-class="is-active"
            >
              <span >ລາຍງານຂໍ້ມູນ Booth</span>
            </router-link>


          </div>
        </div>

        <div class="navbar-item has-dropdown" :class="{ 'is-active': activeDropdown === 'competition' }">
          <a class="navbar-link" @click.prevent="toggleDropdown('competition')">
            <span  >ລາຍການແຂ່ງຂັນ</span>
          </a>
          <div class="navbar-dropdown" v-if="activeDropdown === 'competition'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/participateCompetitionForm"
              :exact="true"
              active-class="is-active"
            >
              <span >ລົງທະບຽນ ໂດຍຜູ້ຈັດງານ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/competitionForm"
              :exact="true"
              active-class="is-active"
            >
              <span >ລາຍງານຜົນການແຂ່ງຂັນ</span>
            </router-link>
          </div>
        </div>

        <div class="navbar-item has-dropdown" :class="{ 'is-active': activeDropdown === 'business' }">
          <a class="navbar-link" @click.prevent="toggleDropdown('business')">
            <span  >ການຈັບຄູ່ທຸລະກິດ</span>
          </a>
          <div class="navbar-dropdown" v-if="activeDropdown === 'business'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/businessMatchingForm"
              :exact="true"
              active-class="is-active"
            >
              <span >ລົງທະບຽນທຸລະກິດ ໂດຍຜູ້ຈັດງານ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/businessMatchingInterested"
              :exact="true"
              active-class="is-active"
            >
              <span >ສຳລັບຜູ້ສົນໃຈ ເລືອກກຸ່ມທຸລະກິດ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/businessMatchingQR"
              :exact="true"
              active-class="is-active"
            >
              <span >Business Matching QR</span>
            </router-link>
          </div>
        </div>

        <div class="navbar-item has-dropdown" :class="{ 'is-active': activeDropdown === 'member' }">
          <a class="navbar-link" @click.prevent="toggleDropdown('member')">
            <span  >ສະມາຊິກ ສະມາຄົມ</span>
          </a>
          <div class="navbar-dropdown" v-if="activeDropdown === 'member'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/association/associationForm"
              :exact="true"
              active-class="is-active"
            >
              <span >ລົງທະບຽນ ໂດຍສະມາຄົມ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/association/associationFormbySelf"
              :exact="true"
              active-class="is-active"
            >
              <span >ລົງທະບຽນ ດ້ວຍຕົວເອງ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/association/registerqr"  
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">Register QR</span>
              <span  v-else>Register QR</span>
            </router-link>
          </div>
        </div>

        <div class="navbar-item has-dropdown" :class="{ 'is-active': activeDropdown === 'information' }">
          <a class="navbar-link" @click.prevent="toggleDropdown('information')">
            <span >ຈັດການຂໍ້ມູນເພີ່ມເຕີ່ມ</span>
          </a>
          <div class="navbar-dropdown" v-if="activeDropdown === 'information'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/information/informationform"
              :exact="true"
              active-class="is-active"
            >
              <span >ປ້ອນຂໍ້ມູນ ໂດຍຜູ້ຈັດງານ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/information/informationbyQR"
              :exact="true"
              active-class="is-active"
            >
              <span >ເບິ່ງຂໍ້ມູນ ໂດຍການສະແກນ QR</span>
            </router-link>
          </div>
        </div>

        <div class="navbar-item has-dropdown" :class="{ 'is-active': activeDropdown === 'Profile' }">
          <a class="navbar-link" @click.prevent="toggleDropdown('Profile')">
            <span >ຂໍ້ມູນສ່ວນຕົວ</span>
          </a>
          <div class="navbar-dropdown" v-if="activeDropdown === 'Profile'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/profile/changepassword"
              :exact="true"
              active-class="is-active"
            >
              <span >ປ່ຽນລະຫັດຜ່ານ</span>
            </router-link>

           
          </div>
        </div>
        <div class="navbar-item is-hoverable" style="margin-left: 10px;">
          <img class="image-area" :src="getLogoutImg()" @click="logout" />
        </div>

        
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "ReportMenu",
  data() {
    return {
      isMenuActive: false, // Toggles the main menu visibility (hamburger menu)
      activeDropdown: null, // Tracks the currently active dropdown menu
      switchLang: 1, // Language switch: 1 for Lao, 2 for English
      photopath: process.env.NODE_ENV === "production" 
                ? "https://lababiz.com/api/uploads/flag/"
                : "http://localhost/lababiz/api/uploads/flag/"
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuActive = !this.isMenuActive; // Toggle the hamburger menu
    },
    toggleDropdown(menu) {
      this.activeDropdown = this.activeDropdown === menu ? null : menu; // Toggle the dropdown
    },
    menuClicked() {
      this.activeDropdown = null; // Close the submenu when an item is clicked
    },
    logout() {
      this.$router.replace("/login");
    },
    getLogoutImg() {
      return this.photopath + "logout.png"; // Return the appropriate flag image
    }
  },
  mounted() {
    this.roleid = this.user.ROLEID;
  },
};
</script>

<style scoped>
.has-dropdown {
  margin-top: 6px;
  margin-left: 12px;
  margin-right: 12px;
}

.navbar-item {
  white-space: nowrap;
  transition: color 0.3s ease;
}

/* Default styles for large screens */
.navbar-item.custom-link {
  color: white; /* Default text color */
  background-color: #039be5;
}

/* Hover effect */
.navbar-item.custom-link:hover {
  /* background-color: #007bff; Background color when hovering */
  color: white; /* Color when hovering */
}

/* Active link state */
.navbar-item.custom-link.is-active {
  /* background-color: #007bff; Background color when the link is active */
  color: white; /* Color when the link is active */
}

.navbar-end {
  padding-right: 60px;
}

.navbar-burger span {
  background-color: white; /* Customize the hamburger menu color */
}

.navbar-link {
  cursor: pointer; /* Pointer cursor for clickable menu links */
}

.navbar-dropdown {
  animation: fadeIn 0.3s; /* Optional fade-in animation for submenu */
}

/* Media query for small screens (hamburger menu active state) */
@media screen and (max-width: 768px) {
  /* Change text color to blue when menu is active on small screens */
  .navbar-menu.is-active .navbar-item.custom-link {
    color: white; /* Change text color to blue for menu items on small screens */
    background-color: #039be5;
  }

  /* On hover, change text color to dark blue */
  .navbar-menu.is-active .navbar-item.custom-link:hover {
    color: white; /* Change text color to blue for menu items on small screens */
    background-color: #039be5;
  }

  .navbar-menu.is-active .navbar-item.custom-link.is-active {
    color: white; /* Change text color to blue for menu items on small screens */
    background-color: #039be5;
  }

  /* Ensure the menu background color is still white on small screens */
  .navbar-menu.is-active {
    background-color: white;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
